<template>
  <div id="app">
    <Navbar/>
	<div class="alert alert-info" role="alert" v-if="false">
		<i class="fas fa-spinner fa-pulse"></i> Loading...
	</div>
    <router-view v-cloak/>
	<print-view/>
	<modal-detail/>
	<modal-account-login/>
	<modal-account-characters/>
	<modal-account-character-versions/>
	<modal-numeric-adjuster/>
	<modal-vitals-adjuster/>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import PrintView from './components/print/Print.vue'
import DetailModal from './components/modals/DetailModal.vue'
import AccountLoginRegister from './components/modals/AccountLoginRegister.vue'
import AccountCharacters from './components/modals/AccountCharacters.vue'
import AccountCharacterVersions from './components/modals/AccountCharacterVersions.vue'
import NumericAdjuster from './components/modals/NumericAdjuster.vue'
import VitalsAdjuster from './components/modals/VitalsAdjuster.vue'

export default {
	name: 'CharacterGallery',
	components: {
		'Navbar': Navbar,
		'PrintView': PrintView,
		'ModalDetail': DetailModal,
		'ModalAccountLogin': AccountLoginRegister,
		'ModalAccountCharacters': AccountCharacters,
		'ModalAccountCharacterVersions': AccountCharacterVersions,
		'ModalNumericAdjuster': NumericAdjuster,
		'ModalVitalsAdjuster': VitalsAdjuster,
	}
}
</script>

<style>
html {
	position: relative;
	min-height: 100%;
}

body {
	/* Margin bottom by footer height */
	display: flex;
	flex-direction: column;
	margin-bottom: 68px;
}
.footer {
	position: absolute;
	flex-shrink: 0;
	bottom: 0;
	width: 100%;
	padding-top: 10px;
	padding-bottom: 10px;
	background-color: #f5f5f5;
}
.view-wrapper {
	padding: 75px 15px 15px;
	margin-bottom: 50px;
}
@media (max-width: 576px) {
	.list-group-column {
		border-bottom: 1px solid rgba(0,0,0,.125) !important;
		border-top: 1px solid rgba(0,0,0,.125) !important;
	}
	.skill-columns{
		column-count: 2;
	}
}

@media (min-width: 576px) {
	.card-columns {
		column-count: 1;
	}
	.skill-columns{
		column-count: 3;
	}
	.list-group-column {
		border-right: 1px solid rgba(0,0,0,.125) !important;
		border-left: 1px solid rgba(0,0,0,.125) !important;
	}
}

@media (min-width: 768px) {
	.card-columns {
		column-count: 1;
	}
	.skill-columns-thick{
		column-count: 2;
	}
}

@media (max-width: 991px){
    .collapse.show {
        overflow-y: auto;
        max-height: 85vh;
    }
}

@media (min-width: 992px) {
	.card-columns {
		column-count: 2;
	}
	.skill-columns {
		column-count: 4;
	}
	.skill-columns-thick{
		column-count: 3;
	}
}

@media (min-width: 1200px) {
	.card-columns {
		column-count: 3;
	}
	.skill-columns {
		column-count: 5;
	}
	.skill-columns-thick{
		column-count: 4;
	}
}

#nprogress .bar {
	background: #FFF !important;
}

</style>
